export const PROOF_OF_TRANSACTION_ACCEPT = ".png,.jpg,.jpeg,.pdf";

export const PROOF_OF_TRANSACTION_ACCEPTED_TYPES = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "application/pdf",
];

export const PROOF_OF_TRANSACTION_MAX_BYTES = 10 * 1024 * 1024;

export const PROOF_OF_TRANSACTION_MAX_SIZE_LABEL = "10MB";
